//Endpoint from Pixels for the Avatar Data
export const avatarBaseUrl = 'https://d31ss916pli4td.cloudfront.net/game/avatars/';
export const endBaseUrl = '.png?v2';